import React from 'react';

const glowKeyframes = `
  @keyframes shGlowPulse {
    0%, 100% { opacity: 0.5; box-shadow: 0 0 8px rgba(0,245,160,0.15), inset 0 0 8px rgba(0,245,160,0.03); }
    50%       { opacity: 1;   box-shadow: 0 0 18px rgba(0,245,160,0.28), inset 0 0 14px rgba(0,245,160,0.06); }
  }
  @keyframes shIconGlow {
    0%, 100% { filter: drop-shadow(0 0 4px rgba(0,245,160,0.5)); }
    50%       { filter: drop-shadow(0 0 10px rgba(0,245,160,0.9)); }
  }
  @keyframes shFloat {
    0%, 100% { transform: translateY(0px); }
    50%       { transform: translateY(-4px); }
  }
`;

const GlowCard = ({
  variant = 'card',
  float = false,
  delay = '0s',
  onClick,
  className = '',
  style = {},
  children,
}) => {
  const base = {
    position: 'relative',
    borderRadius: variant === 'icon' ? '12px' : '16px',
    background: 'rgba(255,255,255,0.03)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    border: '1px solid rgba(0,245,160,0.2)',
    animation: [
      `shGlowPulse 3s ease-in-out infinite`,
      float ? `shFloat 3.5s ease-in-out infinite` : '',
    ].filter(Boolean).join(', '),
    animationDelay: delay,
    cursor: onClick ? 'pointer' : 'default',
    transition: 'border-color 0.2s ease, transform 0.15s ease',
    overflow: 'hidden',
  };

  const iconStyle = {
    ...base,
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px',
    padding: 0,
  };

  const sidebarStyle = {
    ...base,
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    borderRadius: '12px',
    width: '100%',
  };

  const cardStyle = {
    ...base,
    padding: '24px',
    width: '100%',
  };

  const hoverHandlers = onClick
    ? {
        onMouseEnter: (e) => {
          e.currentTarget.style.borderColor = 'rgba(0,245,160,0.45)';
          e.currentTarget.style.transform = float ? '' : 'translateY(-2px)';
        },
        onMouseLeave: (e) => {
          e.currentTarget.style.borderColor = 'rgba(0,245,160,0.2)';
          e.currentTarget.style.transform = 'translateY(0)';
        },
      }
    : {};

  const resolvedStyle =
    variant === 'icon'
      ? { ...iconStyle, ...style }
      : variant === 'sidebar-item'
      ? { ...sidebarStyle, ...style }
      : { ...cardStyle, ...style };

  return (
    <>
      <style>{glowKeyframes}</style>
      <div
        style={resolvedStyle}
        className={className}
        onClick={onClick}
        {...hoverHandlers}
      >
        {children}
      </div>
    </>
  );
};

export const GlowIcon = ({ size = 24, delay = '0s', children }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: size,
      height: size,
      animation: `shIconGlow 3s ease-in-out infinite`,
      animationDelay: delay,
      color: '#00F5A0',
    }}
  >
    {children}
  </span>
);

export default GlowCard;
